import Footer from "../Footer/footer";
import { FirstSection, FourthSection } from "./commonProjectPages";
import { ClientPostatino } from "../Data/clientsData";

function Posticino() {
  return (
    <>
      <div className="container-fluid-eachProject">
        <FirstSection
          projectTitle={ClientPostatino.companyName}
          year={ClientPostatino.year}
          projectType={ClientPostatino.projectType}
          clientCompanyName={ClientPostatino.clientName}
          projectVideo1={ClientPostatino.video1}
          //  projectVideoReel1={Client4.reel1}
          viemoIframe={ClientPostatino.vimeo}
          descriptionFirstSection={ClientPostatino.disc1}
        />
        {/* <SecondSection 
            secondSectionImag1={Client1.beforeImage}
            secondSectionImag2={Client1.afterImage}
            secondSectionDisc1={Client1.beforetext}
            secondSectionDisc2={Client1.afterText}
         />

         <ThirdSection
            mobileVideo1={Client1.mobileVideo}
            videoTitle={Client1.projectTitle}
            thirdDisc={Client1.disc2}
            button1Name='Visit Client’s Social Media'
            button2Name='Contact Us'
            btn1Link={Client1.clientSocialMedia}
            btn2Link={'/contact'}
             
         />
*/}
        <FourthSection
          clientPhoto={ClientPostatino.clientPhoto}
          clientName={ClientPostatino.TestimonilaClientName}
          clientCompany={ClientPostatino.companyName}
          clientTextReview={ClientPostatino.reviewText}
          clientVideoReview={ClientPostatino.reviewVideo}
        />
      </div>

      <Footer />
    </>
  );
}

export default Posticino;
